import React from 'react';
import useDropdown from 'components/dropdown/useDropdown';
import ButtonComponent from 'components/button/buttonComponent';
import { twMerge } from 'tailwind-merge';
import { DropdownBodyContainer } from 'components/dropdown/DropdownBodyContainer';
import { FileOutput } from 'graphql/generated/hasura';
import { ReactComponent as Lab } from 'assets/icons/lab.svg';
import { ReactComponent as Up } from 'assets/icons/upArrow.svg';

interface TestKitButtonBlockProps {
  appointmentId: string;
  diagnosticReports: FileOutput[];
  onClickTestKit: (id: string) => void;
}

const TestKitButtonBlock: React.FC<TestKitButtonBlockProps> = ({
  appointmentId,
  diagnosticReports = [],
  onClickTestKit,
}) => {
  const { registerDropdownRef, openDropdownId, handleDropdownClick } =
    useDropdown();

  return (
    <div className="text-left">
      <div
        className="relative w-full flex items-center justify-center"
        ref={(ref) => registerDropdownRef(appointmentId, ref)}
        onMouseUp={(event) => {
          event.stopPropagation();
          event.preventDefault();
          handleDropdownClick(appointmentId);
        }}
      >
        <ButtonComponent
          testID={`${appointmentId}-details-button`}
          type="underline"
          className="!text-xs !font-bold whitespace-nowrap"
          containerClassName="!gap-1"
          Icon={Lab}
          iconPosition="left"
          iconWidth="w-[1.25rem] !stroke-transparent !fill-current"
        >
          <span>Test kits</span>
          <Up
            className={twMerge(
              openDropdownId !== appointmentId && 'rotate-180',
              'fill-clc-blue w-[12px] h-[6px] ml-1 transition-transform duration-300',
            )}
          />
        </ButtonComponent>
        <DropdownBodyContainer
          align={'right'}
          className={twMerge(
            'desktop:w-max min-w-[200px] w-auto flex flex-col items-start border border-gray-opacity-15 rounded-5',
            'desktop:right-0 right-1/2 translate-x-1/2',
            openDropdownId !== appointmentId && 'hidden',
          )}
        >
          {!!diagnosticReports.length &&
            diagnosticReports.map((file) => {
              if (!file) {
                return null;
              }
              const { fileName, fileId } = file;
              return (
                <button
                  onClick={() => onClickTestKit(fileId ?? '')}
                  className="py-2.5 px-4 text-left text-neutral-800 font-semibold hover:text-clc-blue hover:underline"
                >
                  {fileName}
                </button>
              );
            })}
        </DropdownBodyContainer>
      </div>
    </div>
  );
};

export default TestKitButtonBlock;
